@switch (error) {
  @case ('RESOURCE_UPLOAD_FAILED') {
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { message: 'Upload failed, try again...' }
      " />
  }
  @case ('RESOURCE_GENERATION_FAILED') {
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { message: 'Generation failed, try again..' }
      " />
  }
  @default {
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { message: 'Something unexpected happened...' }
      " />
  }
}

<ng-template #message let-message="message">
  <p-message
    icon="pi pi-exclamation-triangle"
    severity="error"
    variant="simple">
    {{ message }}
  </p-message>
</ng-template>
